var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.level)?_c('div',{staticClass:"access-block"},[_vm._t("default",null,{"level":_vm.level})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }